import React, { useState, KeyboardEvent } from 'react';
import { Chip } from './ui';

interface LabelsInputProps {
  labels: string[];
  onChange: (labels: string[]) => void;
}

const LabelsInput: React.FC<LabelsInputProps> = ({ labels, onChange }) => {
  const [inputValue, setInputValue] = useState('');

  const addLabel = (raw: string) => {
    const label = raw.trim().toLowerCase();
    if (label && !labels.includes(label)) {
      onChange([...labels, label]);
    }
    setInputValue('');
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addLabel(inputValue);
    } else if (e.key === 'Backspace' && inputValue === '' && labels.length > 0) {
      onChange(labels.slice(0, -1));
    }
  };

  const removeLabel = (label: string) => {
    onChange(labels.filter(l => l !== label));
  };

  return (
    <div className="flex min-h-9 flex-wrap items-center gap-1.5 rounded-lg border border-gray-300 bg-white px-2 py-1.5 shadow-sm focus-within:border-indigo-500 focus-within:ring-2 focus-within:ring-indigo-500/20 dark:border-gray-700 dark:bg-gray-900 dark:shadow-none dark:focus-within:border-indigo-400 dark:focus-within:ring-indigo-400/30">
      {labels.map(label => (
        <Chip key={label} selected onRemove={() => removeLabel(label)} removeLabel={`Remove ${label}`}>
          {label}
        </Chip>
      ))}
      <input
        type="text"
        aria-label="Add a label"
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => inputValue.trim() && addLabel(inputValue)}
        placeholder={labels.length === 0 ? 'Type a label and press Enter' : ''}
        className="min-w-[120px] flex-1 border-0 bg-transparent p-0 text-sm outline-none placeholder:text-gray-400 focus:ring-0 dark:text-gray-100 dark:placeholder:text-gray-400"
      />
    </div>
  );
};

export default LabelsInput;
